import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { useAtom, useSetAtom } from 'jotai'
import { PostRequest } from '../../../common/api'
import { urls, xlCol } from '../../../common/constants'
import { alertAtom, globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import LoaderScreen from '../../../common/loader'
import { Item } from '../../../common/snippets'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { userwiseColumnDefs } from './constants'
import moment from 'moment'
import Lineinput from '../../../common/lineinput'
import { fixColSpan } from '../../Reports/common/reportUtils'
import { divideInNIntegers } from '../../../common/mathHelper'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { exportToExcel } from '../../../common/hook'
import Alert from '../../../common/alert'
import { focusElemnt } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'

const UserWiseBalanceTable = (props) => {
    const { reportName, reportData, loginData, saveMeta, criteriaData, criteriaHeaders, onRefreshReport } = props
    const [tableData, setTableData] = useState([])
    const [isSaving, setIsSaving] = useState(false)
    const [alert, setAlert] = useAtom(alertAtom)
    const setLoader = useSetAtom(globalLoaderAtom)
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
    const yesterday = useMemo(
        () => moment().subtract(1, 'day').format('DD-MM-YYYY'),
        []
    )
    useEffect(() => {
        setTableData(reportData || [])
    }, [reportData])
    const isYesterdayRow = (date) => date === yesterday
    const editableKeys = [
        'LLDeliveryExpense',
        'LLOtherExpense',
        'MpesaCollection',
        'ChequeDirectDeposits',
    ]
     const recalculateRow = (row) => {
            const openingBalance = Number(row.OpeningBalance) || 0
            const codAmount = Number(row.CODAmount) || 0
            const paidAmount = Number(row.PaidAmount) || 0
            const llDeliveryExpense = Number(row.LLDeliveryExpense) || 0
            const llOtherExpense = Number(row.LLOtherExpense) || 0
            const mpesaCollection = Number(row.MpesaCollection) || 0
            const chequeDirectDeposits = Number(row.ChequeDirectDeposits) || 0

            const totalRevCollected = codAmount + paidAmount
            const totalExpenseIncurred = llDeliveryExpense + llOtherExpense
            const netRevenueToBeBanked = totalRevCollected - totalExpenseIncurred
            const totalBanking = mpesaCollection + chequeDirectDeposits
            const unbankedCash = netRevenueToBeBanked - totalBanking
            const closingBalance = openingBalance + unbankedCash

            return {
                ...row,
                TotalRevCollected: totalRevCollected,
                TotalExpenseIncurred: totalExpenseIncurred,
                NetRevenueToBeBanked: netRevenueToBeBanked,
                TotalBanking: totalBanking,
                UnbankedCash: unbankedCash,
                ClosingBalance: closingBalance,
            }
        }
    const handleChange = (rowIndex, key, value) => {
        setTableData((prev) => {
            const updated = [...prev]
            const nextRow = {
                ...updated[rowIndex],
                [key]: value === '' ? '' : Number(value),
            }
            updated[rowIndex] = recalculateRow(nextRow)
            return updated
        })
    }
        const handleSave = async () => {
            const yesterdayRow = tableData.find((row) => isYesterdayRow(row.TransactionDate))

            if (!yesterdayRow) {
                setAlert({ show: true, msg: `No row found for ${yesterday}`, nextId: '' })
                return
            }
            const emptyFields = editableKeys.filter((key) => {
                const value = yesterdayRow[key]
                return value === '' || value === null || value === undefined
            })

            if (emptyFields.length > 0) {
                setAlert({show: true, msg: `Please fill all fields. Missing: ${emptyFields.join(', ')}`, nextId: ''})
                return
            }

            setIsSaving(true)
            setLoader(true)

            const payload = {
                CompanyID: Number(saveMeta?.CompanyID) || 0,
                CityID: Number(saveMeta?.CityID) || 0,
                BranchID: Number(saveMeta?.BranchID) || 0,
                UserID: Number(saveMeta?.UserID) || 0,
                TransactionDate: moment(yesterdayRow.TransactionDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                LLDeliveryExpense: Number(yesterdayRow.LLDeliveryExpense) || 0,
                LLOtherExpense: Number(yesterdayRow.LLOtherExpense) || 0,
                NetRevenueToBeBanked: Number(yesterdayRow.NetRevenueToBeBanked) || 0,
                MpesaCollection: Number(yesterdayRow.MpesaCollection) || 0,
                ChequeDirectDeposits: Number(yesterdayRow.ChequeDirectDeposits) || 0,
                ClosingBalance: Number(yesterdayRow.ClosingBalance) || 0,
            }

            try {
                const res = await PostRequest(urls.userWiseBalanceUpdate, payload)

                if (res.status === 'Success') {
                    const refreshedReportData = await onRefreshReport?.()
                    if (refreshedReportData) {
                        setTableData(refreshedReportData)
                    }
                    setAlert({ show: true, success: true, msg: 'User wise balance saved successfully', nextId: '' })
                } else {
                    setAlert({ show: true, msg: 'Failed to save user wise balance', nextId: '' })
                    return
                }
            } catch (err) {
                setAlert({ show: true, msg: err.message, nextId: '' })
            } finally {
                setIsSaving(false)
                setLoader(false)
            }
        }
      const generatepdf = (isSave=false) => {
            jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
            jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

            const pdfHeaderCol = criteriaHeaders.map((col) => ({
              header: col.header,
              dataKey: col.field,
              xlCol: col.xlCol || xlCol,
            }))
            const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })

            doc.autoTableSetDefaults({
                headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
            })
            var totalPagesExp = '{total_pages_count_string}'
            const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
                const doc = data.doc
                // Footer
                var pageSize = doc.internal.pageSize
                var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

                var str = 'Page : ' + doc.internal.getNumberOfPages()
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' of ' + totalPagesExp
                }
                doc.setFontSize(14)
                doc.text(str, doc.internal.pageSize.width - data.settings.margin.left, pageHeight - 5, 'right')
                doc.setFont('Roboto', 'bold')
                doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
                doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 -
                    (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5
                )
            }
            doc.setProperties({
                title: `Banking Report.pdf`,
                subject: 'Report',
                author: 'Maven Tech Labs Pvt. Ltd.',
                keywords: 'maven tech, Cargo system, Banking Report',
                creator: 'MTLPL',
            })
            autoTable(doc, {
                margin: { top: 180, left: 30, right: 30, bottom: 0 },
                alternateRowStyles: {
                    fillColor: [255, 255, 255],
                },
                columns: pdfHeaderCol,
                body: [criteriaData],
                columnStyles: {
                    0: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    1: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    2: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                    3: { fontSize: 14, font: 'Roboto', valign: 'middle', minCellWidth: 236, halign: 'left', minCellHeight: 36, cellPadding: 12, fontStyle: 'normal', textColor: [0, 0, 0], },
                },
                theme: 'grid',
                showHead: 'everyPage',
                styles: {
                    fontStyle: 'bold',
                    fontSize: 15,
                },
                headStyles: {
                    halign: 'left',
                    valign: 'middle',
                    cellPadding: 12,
                    fontSize: 15,
                    minCellHeight: 36,
                    fillColor: [182, 222, 254],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold',
                    font: 'Roboto',
                    lineWidth: 0.6,
                },
            })
            const secondTableColumnStyles = {
                0: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 41, halign: 'center', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                1: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 90, halign: 'left', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                2: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 80, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                3: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 70, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                4: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 75, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                5: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 90, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                6: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 90, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                7: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 75, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                8: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 80, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                9: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 80, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                10: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 90, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                11: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 75, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                12: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 85, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                13: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 75, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
                14: { fontSize: 14, font: 'Roboto', valign: 'middle', cellWidth: 85, halign: 'right', minCellHeight: 36, cellPadding: 6, fontStyle: 'normal', textColor: [0, 0, 0] },
            }
            autoTable(doc, {
                margin: { top: 180, left: 30, right: 30, bottom: 40 },
                alternateRowStyles: {
                    fillColor: [255, 255, 255],
                },
                startY: doc.lastAutoTable.finalY + 24,
                columns: userwiseColumnDefs,
                body: tableData,
                columnStyles: secondTableColumnStyles,
                theme: 'grid',
                styles: {
                    fontSize: 15,
                    lineWidth: [0, 0.6, 0, 0.6],
                    fontStyle: 'bold',
                },
                tableLineWidth: 0.6,
                headStyles: {
                    fontSize: 15,
                    fillColor: [182, 222, 254],
                    textColor: [0, 0, 0],
                    cellPadding: 6,
                    valign: 'middle',
                    fontStyle: 'bold',
                    font: 'Roboto',
                },
                didParseCell: (data) => {
                    if (data.row.section === 'head' || data.row.section === 'body') {
                        if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                            data.cell.styles.halign = 'right'
                        } else {
                            data.cell.styles.halign = 'left'
                        }
                    }
                    if (data.row.raw.isSubHeading) {
                        data.row.cells[0].colSpan = userwiseColumnDefs?.length;
                    }
                },

                willDrawCell: (data) => {
                    if (data.row.raw.isSubHeading) {
                        doc.setFillColor(218, 237, 254);
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(15).setFont("Roboto", 'bold')
                        data.cell.styles.valign = 'middle';
                    } else if (data.row.raw.isTotalRow) {
                        doc.setFillColor(238, 238, 238);
                        doc.setTextColor(0, 0, 0);
                        doc.setFontSize(15).setFont("Roboto", 'bold')
                        data.cell.styles.valign = 'middle';
                    }
                },
                didDrawPage: function (data) {
                    doc.setTextColor(0, 0, 0)
                    doc.setFontSize(16)
                    doc.setFont('Roboto', 'bold')
                    doc.text(`Booking Date : ${moment(saveMeta?.fromDate).format('DD-MMM-YYYY')} To ${moment(saveMeta?.toDate).format('DD-MMM-YYYY')}`, 30, 145)
                    doc.setFontSize(16)
                    doc.setFont('Roboto', 'bold')
                    doc.text(`Report:Banking Report`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                    doc.setTextColor(40)
                    doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                    doc.setFontSize(20).setFont('Roboto', 'bold')
                    doc.setTextColor(16, 79, 162)
                    doc.text('Cargo System | Accounting Reports', 30 + 60, 80)
                    doc.setTextColor(0, 0, 0)
                    doc.setFontSize(20).setFont('Roboto', 'bold')
                    doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
                    jsPdfHeaderFooter(data, loginData, totalPagesExp)
                },
            })
            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp)
            }
            const pdfBlob = new Blob([doc.output('blob')], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            if(isSave){
                doc.save(`${reportName} ${currentDateTime}.pdf`)
            }else{
                // Open the PDF in a new tab
                window.open(pdfUrl);
            }
        }
    const handleAlert = (msg = false, nextId = '') => {
        if (!(msg instanceof Event)) {
            if (msg) {
                setAlert({ show: true, msg })
            } else {
                setAlert({ show: false, msg: '' })
                setTimeout(() => {
                    focusElemnt(nextId)
                }, 0)
            }
        }
        updateAlertError({ show: false, msg: '' })
    }
    let excelColumnDefs = userwiseColumnDefs?.map((col) => ({ ...col, field: col.dataKey }))
    const span1 = divideInNIntegers(excelColumnDefs.length, 2)
    const [criteriaHeaderExcel, criteriaDataExcel] = fixColSpan(criteriaHeaders, [criteriaData], excelColumnDefs)
    let excelDataList = [[], criteriaDataExcel]
    excelDataList.push([...tableData])
    const header1 = [
        [
            { header: `Report For: Banking Report: ${reportName}`, field: '', span: span1[0], mainHeader: true },
            { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
        ],
    ]
    const excelHeaderList = [header1, criteriaHeaderExcel, excelColumnDefs]
    return (
    <>
        {isSaving && <LoaderScreen />}
        <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', padding: '10px 20px', width: '100%' }}>
            <Box sx={{ ...sx.reportFlex, flexWrap: 'nowrap', padding: '0px' }}>
                <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px', padding: '0px 5px 5px 5px' }}>
                    <h3 style={{ textAlign: 'left', color: '#444' }}>Report For: Userwise Balance Summary </h3>
                </Box>
                <Box
                    className='reportButton'
                    style={{
                        display: 'flex',
                        width: '50%',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: '16px',
                        padding: '0px 5px 5px 5px'
                    }}
                >

                    <>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button
                                variant="contained"
                                // onKeyDown={(e) => navigation3(e, 'fromDate', 'QRPaymentActive', () => { })}
                                id={'update_btn'}
                                sx={{ padding: '6px 20px !important', fontSize: '14px !important' }}
                                className="btn btn-primary"
                               disabled={isSaving}
                               onClick={handleSave}
                            >
                                {isSaving ? 'Saving...' : 'Save'}
                            </Button>
                        </Item>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button id={"print"} variant="outlined" className="receiveitembtn"
                                   onClick={() => { generatepdf(false) }}
                                onKeyDown={(e) => {
                                    // navigation1(e, showTable ? 'QRPaymentActive' : '', 'excelBtn')
                                }}
                            >
                                Print
                            </Button>
                        </Item>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button id={"print"} variant="outlined" className="receiveitembtn"
                                   onClick={() => { generatepdf(true) }}
                                onKeyDown={(e) => {
                                    // navigation1(e, showTable ? 'QRPaymentActive' : '', 'excelBtn')
                                }}
                            >
                                Export To PDF
                            </Button>
                        </Item>
                        <Item sx={{ ...sx.itemsx }} className="">
                            <Button
                                variant="outlined"
                                color="secondary"
                                id={'excelBtn'}
                                sx={{ width: '100%' }}
                                className="receiveitembtn"
                               onClick={(e) => {
                                   exportToExcel({
                                       fileName: `Banking Report: ${reportName} ${currentDateTime}.xlsx`,
                                       sheetName: reportName,
                                       headersList: excelHeaderList,
                                       dataList: excelDataList,
                                   })
                               }}
                            // onKeyDown={(e) => navigation1(e, 'print', 'refreshBtn')}
                            >
                                Export To Excel
                            </Button>

                        </Item>
                    </>
                </Box>
            </Box>
            <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '70vh' }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            {userwiseColumnDefs?.map((col, index) => (
                                <TableCell
                                    key={`CityHeader-${index}`}
                                    style={{
                                        ...col.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px',
                                        whiteSpace: 'pre',
                                        padding: '6px',
                                        whiteSpace: 'pre'
                                    }}>
                                    {col.header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {tableData?.length > 0 ?
                        <TableBody>
                            {tableData.map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    {userwiseColumnDefs.map((col) => {
                                        const key = col.dataKey
                                        const value = row[key]

                                        const showInput =
                                            editableKeys.includes(key) &&
                                            isYesterdayRow(row.TransactionDate)

                                        return (

                                            <TableCell key={key} style={{ height: '40px', fontSize: '12px', fontWeight: '600', color: '#444', padding: '6px', width: '5%', textAlign: col.headerSx?.textAlign || 'left' }}>
                                                {showInput ? (
                                                    <div
                                                        className={'input--wrapper'}
                                                        style={{
                                                            width: '100%',
                                                            margin: '0px',

                                                        }}
                                                    >
                                                        <Lineinput
                                                            id=''
                                                            value={value ?? ''}
                                                            onChange={(e) =>
                                                                handleChange(
                                                                    rowIndex,
                                                                    key,
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{ height: '10px' }}
                                                        /></div>
                                                ) : (
                                                    value
                                                )}
                                            </TableCell>
                                        )
                                    })}
                                </TableRow>
                            ))}
                        </TableBody> :
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={userwiseColumnDefs?.length + 1}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>No Results Found For The Selected Filters.</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>}

                </Table>
            </TableContainer>
        </Box>
        {alert.show && (
            <Alert
                msg={alert.msg}
                error={!alert?.success}
                success={alert?.success || false}
                close={() => (alert.close ? alert.close() : handleAlert(false, alert.nextId))}
            />
        )}
    </>
    )
}

export default UserWiseBalanceTable
